import React, { useEffect, useState } from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ModalHelp from '../../../components/ModalHelp';
import BackendErrorMessage from '../../../components/BackendErrorMessage';
import { ProcessoViewModel } from '../../../viewmodel/ProcessoViewModel';

interface IntegracaoCandidatosModalProps {
  show: boolean;
  processoId: string;
  processoNome: string;
  onClose: () => void;
  onSuccess: () => void;
}

const IntegracaoCandidatosModal: React.FC<IntegracaoCandidatosModalProps> = ({
  show,
  processoId,
  processoNome,
  onClose,
  onSuccess
}) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [integracaoAberta, setIntegracaoAberta] = useState(false);

  useEffect(() => {
    if (!show) return;
    loadStatus();
  }, [show, processoId]);

  const loadStatus = async () => {
    try {
      setLoading(true);
      const status = await ProcessoViewModel.consultarIntegracaoCandidatos(processoId);
      setIntegracaoAberta(status);
    } catch (error) {
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    try {
      setSaving(true);
      if (integracaoAberta) {
        await ProcessoViewModel.finalizarIntegracaoCandidatos(processoId);
        toast.success('Integração de candidatos fechada com sucesso!');
      } else {
        await ProcessoViewModel.abrirIntegracaoCandidatos(processoId);
        toast.success('Integração de candidatos aberta com sucesso!');
      }
      onSuccess();
      onClose();
    } catch (error) {
      toast.error(BackendErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Integração de Candidatos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalHelp text="Abra ou feche a integração de candidatos com sistemas externos. Quando aberta, sistemas integrados podem enviar candidatos para este processo. Feche a integração quando todos os candidatos já tiverem sido importados." />
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : (
          <>
            <p><strong>Processo:</strong> {processoNome}</p>
            <div style={{ marginBottom: '12px' }}>
              <strong>Status atual:</strong>{' '}
              <Badge bg={integracaoAberta ? 'success' : 'secondary'}>
                {integracaoAberta ? 'Aberta' : 'Fechada'}
              </Badge>
            </div>
            <p style={{ marginBottom: 0 }}>
              {integracaoAberta
                ? 'Desabilita a integração de candidatos para este processo, bloqueando integração de candidatos/fotos e impedindo que Unidades parceiras gerenciem candidatos para este processo.'
                : 'Permite que Unidades parceiras gerenciem candidatos e fotos para este processo via integração. Ao abrir, os endpoints de integração de candidatos/fotos para este processo serão liberados.'}
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant={integracaoAberta ? 'danger' : 'success'}
          onClick={handleConfirm}
          disabled={loading || saving}
        >
          {saving ? 'Processando...' : integracaoAberta ? 'Fechar Integração' : 'Abrir Integração'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IntegracaoCandidatosModal;
